import { datadogRum } from '@datadog/browser-rum';

const addDatadogRequestError = (error, context = {}) => {
  // Create new error with modified message
  const enrichedError = new Error(`Request Error - ${error.message}`);
  // Set stack at construction time
  Object.defineProperty(enrichedError, 'stack', {
    value: error.stack,
    enumerable: true,
  });

  datadogRum.addError(enrichedError, context);
};

export default addDatadogRequestError;
